import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const MODES = [
  { key: null,          label: "Admin",           path: "/admin"    },
  { key: "delivery",    label: "Delivery Staff",  path: "/delivery" },
  { key: "event_staff", label: "Event Staff",     path: "/scan"     },
  { key: "customer",    label: "Customer",        path: "/"         },
  { key: "referral",    label: "Referral Holder", path: "/profile"  },
];

export default function OwnerViewBar() {
  const { isOwner, viewAs, setViewAs } = useAuth();
  const navigate = useNavigate();

  if (!isOwner) return null;

  const handleSwitch = (mode) => {
    setViewAs(mode.key);
    navigate(mode.path);
  };

  return (
    <div style={{
      position:       "fixed",
      bottom:         0,
      left:           0,
      right:          0,
      zIndex:         9999,
      background:     "#111",
      borderTop:      "1px solid #333",
      display:        "flex",
      alignItems:     "center",
      gap:            8,
      padding:        "7px 16px",
      fontFamily:     "inherit",
      overflowX:      "auto",
      WebkitOverflowScrolling: "touch",
    }}>
      <span style={{ fontSize: 11, color: "#555", marginRight: 4, letterSpacing: "0.5px", flexShrink: 0 }}>
        VIEWING AS
      </span>
      {MODES.map((mode) => {
        const active = viewAs === mode.key;
        return (
          <button
            key={String(mode.key)}
            onClick={() => handleSwitch(mode)}
            style={{
              padding:        "4px 14px",
              border:         "1px solid",
              borderRadius:   20,
              fontSize:       11,
              fontWeight:     600,
              cursor:         "pointer",
              fontFamily:     "inherit",
              letterSpacing:  "0.3px",
              transition:     "all .15s",
              whiteSpace:     "nowrap",
              flexShrink:     0,
              borderColor:    active ? "#fff" : "#383838",
              background:     active ? "#fff" : "transparent",
              color:          active ? "#111" : "#666",
            }}
          >
            {mode.label}
          </button>
        );
      })}
    </div>
  );
}
